import { Culture } from '../../../../FrontEndReact/src/Core/Types/culture';
import { getAngularJsService } from '../../../../Js/React/Services/legacy';
import { CustomConfig, ImportType } from '../Types/import';

export function showDirtyDialogLegacy(): Promise<boolean> {
	const service = getAngularJsService('admin.core.service');
	return new Promise((resolve) => {
		service.ShowDirtyWarning().then((okToLeave) => {
			resolve(okToLeave);
		});
	});
}
export function GetSelectedCulture() {
	const rootScope = getAngularJsService('$rootScope');
	return rootScope.SelectedCulture as Culture;
}

export function SetSelectedCulture(culture: Culture) {
	const rootScope = getAngularJsService('$rootScope');

	//prefer the same objects from the cultures list if possible, to avoid issues with reference equality in AngularJS
	const cultures = rootScope.Cultures as Culture[];
	const foundCulture = cultures?.find((c) => c.Id === culture.Id);
	rootScope.SelectedCulture = foundCulture ?? culture;
}

export function reInitializeLegacy() {
	const rootScope = getAngularJsService('$rootScope');
	rootScope.ReInitialize();
}

export function showEditorDialogLegacy(content: string, styles: string): Promise<{ content: string; styles?: string } | null> {
	const service = getAngularJsService('admin.core.service');
	return new Promise((resolve) => {
		service.ShowEditorDialog(content, styles).then((result: { content: string; styles?: string } | null) => {
			if (!result) {
				resolve(null);
				return;
			}
			resolve(result);
		});
	});
}
export function showCodeEditorDialogLegacy(content: string, language: string): Promise<string | null> {
	const service = getAngularJsService('bizCodeEditorService');
	return new Promise((resolve) => {
		service.OpenEditorAsDialog(content, language).then((content) => {
			resolve(content);
		});
	});
}

export function showImportDialogLegacy<FrontEndConfig>(
	importType: ImportType,
	customConfig?: Partial<CustomConfig<FrontEndConfig>>,
	customImportTypeName?: string
): Promise<boolean> {
	const service = getAngularJsService('bizImportService');
	return new Promise((resolve) => {
		service.ShowImportDialog(importType, customConfig, customImportTypeName).then(() => {
			resolve(true);
		});
	});
}
